import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { DialogActions } from '@e3dc-react/shell/Elements/Dialog/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import useInstallationFiles from '../../Libs/documents/hooks/use-installation-files'
import { useTypedSelector } from 'src/State/RootReducer'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import { FileWithLatestStatus } from 'src/Libs/installation-statement/models'
import { Typography } from '@e3dc-react/shell/Elements/Typography'

const useStyles = makeStyles()(theme => ({
  image: {
    marginTop: theme.spacing(2),
    width: '100%',
    height: '100%',
  },
}))

export interface ImagePreviewProps {
  onClose?: () => void
  place?: number
  file: FileWithLatestStatus
  url: string | undefined
  /** setImagePreviewOpened is used to prevent opening two modals */
  setImagePreviewOpened: (value: boolean) => void
}

const ImagePreviewModal: React.FC<ImagePreviewProps> = ({ onClose, place, file, url, setImagePreviewOpened }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { downloadFile } = useInstallationFiles()
  const activeInstallation = useTypedSelector(state => state.storage.activeInstallation)

  const handleDownload = (): void => {
    if (activeInstallation) downloadFile(Number(activeInstallation), file)
  }

  const getDialogActions = (): DialogActions => {
    return {
      primary: {
        name: t('common.download'),
        onClick: handleDownload,
      },
      secondary: [
        {
          name: t('common.cancel'),
        },
      ],
    }
  }

  return (
    <Dialog
      title={t('imagePreviewModal.title')}
      maxWidth="sm"
      onClose={() => {
        setImagePreviewOpened(false)
        onClose?.()
      }}
      place={place}
      actions={getDialogActions()}
    >
      {url ? (
        <Box component="img" src={url} alt={'preview'} className={classes.image} />
      ) : (
        <Typography>{t('imagePreviewModal.no-preview-available')}</Typography>
      )}
    </Dialog>
  )
}

export default ImagePreviewModal
